'use strict';
import React, {useState, useRef} from 'react';
import './App.css';

import rain from './audio/rain.mp3';
import coffeeshop from './audio/coffeeshop.mp3';
import library from './audio/library.wav';
import fireplace from './audio/fireplace.wav';
import beach from './audio/beach.wav';
import fan from './audio/fan.mp3';

// Amb Audio
// When clicked, sound should play. When clicked again, sound should stop
// When other button is clicked, swap

function AmbAudio() {
    const audios = {
        'rain': rain,
        'coffeeshop': coffeeshop,
        'library': library,
        'fireplace': fireplace,
        'beach': beach,
        'fan': fan
}

    const [currentAudio, setCurrentAudio] = useState(null);
    const [currentLabel, setCurrentLabel] = useState(null);
    const [volume, setVolume] = useState(1);

    function toggleAudio(track) {
        // three interactions: stop music, start music, and change to other music

        if (!currentAudio) {
            const newAudio = new Audio(track);
            setCurrentAudio(newAudio);
            setCurrentLabel(track);
            newAudio.play();
        } else if (currentAudio && currentLabel === track){
            currentAudio.pause();
            setCurrentAudio(null);
        } else {
            currentAudio.pause()
            setCurrentAudio(null);

            const newAudio = new Audio(track);
            setCurrentAudio(newAudio);
            setCurrentLabel(track);
            newAudio.play();
    }
}

function handleVolume(value) {
    if (currentAudio) {
    setVolume(value);
    currentAudio.volume = volume;
    }
}
    
    return(
        <div className="amb-toggle">
        <div className="section-container section-amb">
        <h1>Ambience</h1>
            <div className="section-item">
                <div className="ambient-container">
                    <div className="ambient-item" onClick={() => toggleAudio(audios.rain)}>
                        <img src="img/rain.avif" alt="Rain"/>
                    </div>
                    <div className="ambient-item" onClick={() => toggleAudio(audios.coffeeshop)}>
                        <img src="img/coffee.avif" alt="Cafe"/>
                    </div>
                    <div className="ambient-item" onClick={() => toggleAudio(audios.library)}>
                        <img src="img/library.jpg" alt="Library"/>
                    </div>
                    <div className="ambient-item" onClick={() => toggleAudio(audios.fireplace)}>
                        <img src="img/fireplace.avif" alt="Fireplace"/>
                    </div>
                    <div className="ambient-item" onClick={() => toggleAudio(audios.beach)}>
                        <img src="img/beach.avif" alt="Beach Waves"/>
                    </div>
                    <div className="ambient-item" onClick={() => toggleAudio(audios.fan)}>
                        <img src="img/fan.avif" alt="Ceiling Fan"/>
                    </div>
                </div>
            </div>

            <div className="section-item">
            <div className="volume-container">
            <img className="volume-item" src="./img/unmuted.png" />
                <input className="volume-slider"
                type="range"
                min={0}
                max={1}
                step={0.02}
                value={volume}
                onChange={event => {
                    handleVolume(event.target.valueAsNumber)
                }} 
                />
                </div>
                </div>
        </div>
        </div>
    );

}

export default AmbAudio;